import shuffle from "seneca-common/utils/functions/random/shuffle";

import { Content, ContentSource } from "../types";

export const makeGenerateContent = (shuffleValues: boolean = false) => {
  return (source: ContentSource): Content => {
    const { statement, values: sourceValues, numRequiredAnswers } = source;
    const values = shuffleValues ? shuffle(sourceValues) : sourceValues;

    return {
      statement,
      values,
      numRequiredAnswers
    };
  };
};

export const generateContent = makeGenerateContent(true);
